import { ResourceAction } from '../../../authentication/authorization-service';
import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import { openRankedSearch } from '../../../areas/ranked-search/components/search-drawer/search-drawer-container';
import { formatCpr, formatCprNoDash, isValidCpr } from '../../../utilities/cpr-helper';
import { isValidProductionUnitIdentifier } from '../../../utilities/production-unit-identifier-helper';
import { OmnibarEntry } from '../omnibar-interfaces';
import { catalogCorrectionsToggle } from '../utils/catalog-corrections';

const citizenCreate: ResourceAction[] = [{ resourceOperation: ResourceOperations.Citizen.Create, resourceType: ResourceTypes.Citizen }];
const companyWrite: ResourceAction[] = [{ resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.Company }];

const findOrCreateCitizenByCprId = 'find-or-create-citizen-by-cpr';
const findOrCreateCompanyByProductionUnitId = 'find-or-create-company-by-production-unit';

export function isRecordIdentifierEntry(entry: OmnibarEntry) {
  return entry.id === findOrCreateCitizenByCprId || entry.id === findOrCreateCompanyByProductionUnitId;
}

const functions: OmnibarEntry[] = [
  {
    id: '5c2e8a1f-7d3b-4e9a-b6c4-1f8d3a7e2b95',
    label: 'Opret borger',
    keywords: ['ny borger', 'hent borger', 'cpr', 'dfdg'],
    context: 'none',
    group: 'Borgere',
    callbackFn: () => openRankedSearch('', 'citizen'),
    resourceActions: citizenCreate,
    featureToggleRequired: catalogCorrectionsToggle,
    requiresRecordSearch: true,
    opensIn: 'dialog',
  },
  {
    id: 'e7a3c9d5-2b6f-4d1e-8a4c-9b5f2d7e1c38',
    label: 'Opret virksomhed',
    keywords: ['ny virksomhed', 'hent virksomhed', 'p-nummer', 'cvr'],
    context: 'none',
    group: 'Virksomheder',
    callbackFn: () => openRankedSearch('', 'company'),
    resourceActions: companyWrite,
    featureToggleRequired: catalogCorrectionsToggle,
    requiresRecordSearch: true,
    opensIn: 'dialog',
  },
];

// Kept out of the catalog so a typed CPR number never lands in top results or recent selections.
export function recordIdentifierEntries(query: string): OmnibarEntry[] {
  const entries: OmnibarEntry[] = [];
  if (isValidCpr(query)) {
    const cpr = formatCprNoDash(query);
    entries.push({
      id: findOrCreateCitizenByCprId,
      label: `Find eller opret borger med CPR ${formatCpr(cpr)}`,
      actionType: 'Opret',
      context: 'none',
      group: 'Borgere',
      callbackFn: () => openRankedSearch(cpr, 'citizen'),
      resourceActions: citizenCreate,
      featureToggleRequired: catalogCorrectionsToggle,
      requiresRecordSearch: true,
      opensIn: 'dialog',
    });
  }
  if (isValidProductionUnitIdentifier(query)) {
    entries.push({
      id: findOrCreateCompanyByProductionUnitId,
      label: `Find eller opret virksomhed med P-nummer ${query}`,
      actionType: 'Opret',
      context: 'none',
      group: 'Virksomheder',
      callbackFn: () => openRankedSearch(query, 'company'),
      resourceActions: companyWrite,
      featureToggleRequired: catalogCorrectionsToggle,
      requiresRecordSearch: true,
      opensIn: 'dialog',
    });
  }
  return entries;
}

export default functions;
